/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Role } from '../models/Role';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminRoleService {

    /**
     * Get list of roles
     * @returns Role Success
     * @throws ApiError
     */
    public static getAdminRole({
        companyId,
    }: {
        /**
         * Company ID
         */
        companyId: number,
    }): CancelablePromise<Array<Role>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/role',
            query: {
                'companyId': companyId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
